import {DateTime} from 'luxon'

export default (value?: DateTime) => {
  if(!value) return ''
  if([1, 2].includes(value.quarter)) return '상반기'
  if([3, 4].includes(value.quarter)) return '하반기'
  return ''
}
